<template>
  <div @click="createIframe" class="wrapper pt_20 pl_20 pr_20 pb_20">
    <div class="mb_20">尝试拉起{{curApp.name}}...</div>
    <!-- {{ urlScheme }} -->
    <div
      style="color: #1677FF; text-decoration: underline;"
      @click.stop="openDownload"
    >页面无响应？点我尝试解决>></div>
    <ActivityPopup
      :visible.sync="visible"
      v-bind="feedback"
      showCancelButton
      @confirm="feedback.onSure"
      @cancel="feedback.onCancel"
    >
    </ActivityPopup>
  </div>
</template>

<script>
import JumpMain from './jump'
export default {
  name: 'JumpToHezi',
  mixins: [JumpMain],
  mounted () {
    this.init()
    setTimeout(() => {
      document.title = '跳转至' + this.curApp.name
    }, 100)
  },
  methods: {
    handleDownload () {
      console.log('open-->', this.curApp.downloadUrl)
      window.location.href = this.curApp.downloadUrl;
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100vw;
  height: 100vh;
}
</style>
